import { Component, Optional } from '@angular/core';
import { DynamicFormService, SaveCloseItemActionComponent } from '@ntap/common';
import {
  BackendUploadService,
  Item,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewWindow
} from '@ntap/core';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-save-close-kreiranje-fizickih-objekata-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./save-close-kreiranje-fizickih-objekata-action.component.scss']
})
export class SaveCloseKreiranjeFizickihObjekataActionComponent extends SaveCloseItemActionComponent {
  constructor(
    @Optional() protected override window: ViewWindow, // TODO izbaciti Optional
    protected override itemProvider: ItemProvider,
    protected override itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected override formService: DynamicFormService,
    protected override notificationService: NotificationService,
    protected override backendUploadService: BackendUploadService,
    protected listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(
      window,
      itemProvider,
      itemViewProvider,
      formService,
      notificationService,
      backendUploadService
    );
  }

  protected override doExecuteWithItem(item: Item): Observable<any> {
    return super.doExecuteWithItem(item).pipe(
      tap(() => {
        this.listViewProvider.refresh();
      })
    );
  }
}
